module.exports = __webpack_public_path__ + "img/summary-report.988c77b5.png";